import React, {
  useState,
  useEffect,
  componentDidMount,
  useCallback
} from "react";
import AreaOne from "../Dashboard/AreaOne";
import LangageStateChart from "../Dashboard/LangageStateChart";
import TempsReponsePerformances from "../Dashboard/TempsReponsePerformances ";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Container,
  Label,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import AnalyseMessageSavJour from "../Dashboard/AnalyseMessageSavJour";
import AnalyseMessageSavHeure from "../Dashboard/AnalyseMessageSavHeure";
import StateChart from "../Dashboard/StateChart";
import SentimentChart from "../Dashboard/SentimentChart";
import ProgressionBar from "../Dashboard/ProgressionBar";
import Knob from "../AllCharts/knob/knob";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import Flatpickr from "react-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import { english } from "flatpickr/dist/l10n/default.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { Client, Account, Databases, Query } from "appwrite";
// import LineChart from '../AllCharts/chartjs/linechart';
import VectorMaps from "../chat/Maps";
import axios from "axios";
import TagsList from "../Dashboard/TagsList";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useNavigate } from "react-router-dom";
import ReceiveMail from "./receiveMail";
import ClientsSentiments from "./ClientsSentiments";
import Ratio from "./ratio";
import AreaTwo from "./AreaTwo";
import Turnover from "./turnover";
import TreatedMail from "./treatedMail";
import Apaexlinecolumn from "./apaexlinecolumn";
import ClientSentiments from "./clientSentiments";
import VueGlobale from "./../Dashboard/VueGlobale";
import UntreatedEmail from "./untreatedEmail";
import TreatedEmail from "./treatedEmail";
import VerticalComposedChart from "./VerticalComposedChart";
import Langues from "./langue";
import ClientsMonde from "./clientsMonde";
import { withTranslation } from "react-i18next";
import RetoursClients from "../Dashboard/RetoursClients";

import love from "../../assets/images/love.png";
import hate from "../../assets/images/hate.png";
import neutral from "../../assets/images/neutral.png";
import TurnoverAi from "./turnoverAi";
import Efficiency from "./efficiency";
import RangeDatepicker from "../../components/Common/rangeDatepicker/RangeDatepicker";
import { fetchStatistics } from "../../helpers/api_helper";

const Analytics = (props) => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [mailMessages, setMailMessages] = useState([]);
  const [untreatedMessage, setUntreatedMessage] = useState([]);
  const [treatedMessage, setTreatedMessage] = useState([]);
  const [selectedDates, setSelectedDates] = useState({
    first: Date.now() - 7 * 24 * 60 * 60 * 1000,
    last: Date.now()
  });
  const [messagesSentiments, setMessagesSentiments] = useState({
    happy: 0,
    angry: 0,
    neutral: 0
  });
  const [messageInfos, setMessageInfos] = useState({});
  const [loading, setLoading] = useState(false);
  const [client_data, setCompanyInfos] = useState();
  const [error, setError] = useState(undefined);
  const the_folder = "INBOX";
  const [hoverText, setHoverText] = useState([]);
  const [messages_data, setMessagesData] = useState([]);
  const [pageStatisticsList, setPageStatisticsList] = useState([]);
  const [aggregation, setAggregation] = useState("H4");
  let companyId = undefined;

  document.title = props.t("Analytics") + " | Synibox - Smart Assistant";

  const navigate = useNavigate();

  const onMessageDataChange = (data) => {
    setMessagesData(data);
  };

  const onUntreatedMessageChange = (data) => {
    setUntreatedMessage(data);
  };
  const onTreatedMessageChange = (data) => {
    setTreatedMessage(data);
  };
  async function getMessageData(date) {
    console.log("getMessageData dates are", date);
    const client = new Client();
    const databases = new Databases(client, "default");
    if (!companyId) {
      companyId = localStorage.getItem("companyId");
    }
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    return databases
      .listDocuments("default", "message", [
        // Query.equal("company", companyId),
        Query.greaterThanEqual("message_date", parseInt(date[0])),
        Query.lessThanEqual("message_date", parseInt(date[1]))
      ])
      .then(
        function (response) {
          var data = response.documents;
          onMessageDataChange(data);

          console.log("Nbre de messages_data :", data.length);
          console.log("Messages_data is :", data);
          const treatedMessagesList = [];
          const unTreatedMessagesList = [];
          data.forEach((message) => {
            if (message.process_state === "Treated") {
              treatedMessagesList.push(message);
            } else if (message.process_state === "Untreated") {
              unTreatedMessagesList.push(message);
            }
          });
          onTreatedMessageChange(treatedMessagesList);
          onUntreatedMessageChange(unTreatedMessagesList);

          const sentiments = data.map((message) => message.client_sentiment);
          console.log("Liste des sentiments :", sentiments);
          const sentimentObj = {
            happy: [],
            angry: [],
            neutral: []
          };

          sentiments.forEach((sentiment) => {
            console.log("sentiment is:", sentiment);
            if (sentiment === "happy") {
              sentimentObj.happy.push(sentiment);
            } else if (sentiment === "angry") {
              sentimentObj.angry.push(sentiment);
            } else {
              sentimentObj.neutral.push(sentiment);
            }
          });
          // setMessagesSentiments(sentimentObj);
          // console.log("messagesSentiments:", sentimentObj);
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message data:", error);
        }
      );
  }
  async function getTreatedMessageData(date) {
    console.log("getMessageData", date);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    return databases
      .listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.greaterThanEqual("message_date", parseInt(date[0])),
        Query.lessThanEqual("message_date", parseInt(date[1])),
        Query.equal("process_state", "Treated")
      ])
      .then(
        function (response) {
          var data = response.documents;
          console.log("onTreatedMessageChange", data);

          onTreatedMessageChange(data);
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message data:", error);
        }
      );
  }

  async function getUntreatedMessageData(date) {
    console.log("getMessageData", date);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    return databases
      .listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.greaterThanEqual("message_date", parseInt(date[0])),
        Query.lessThanEqual("message_date", parseInt(date[1])),
        Query.equal("process_state", "Untreated")
      ])
      .then(
        function (response) {
          var data = response.documents;
          onUntreatedMessageChange(data);
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message data:", error);
        }
      );
  }

  const fetchMails = async function () {
    onLoading(true);
    // Helper function for making the API request
    const makeApiRequest = async function (apiUrl, folder) {
      axios
        .get(apiUrl, {
          params: {
            company_id: localStorage.getItem("companyId"),
            folder,
            page: 1,
            limit: 20,
            day_since: 30
          }
        })
        .then(async (response) => {
          console.log("UntreatedMessageData is", response);
          // setMessages(response.mails);
          setMailMessages(response.mails);
          // setTotalPage(response.totalPages);
          // setTotalMails(response.totalMails);
          for (const message of response.mails) {
            let messageId = "";
            if (typeof message.headers["message-id"] === "string") {
              messageId = message.headers["message-id"];
            } else if (Array.isArray(message.headers["message-id"])) {
              messageId = message.headers["message-id"][0];
            }
          }

          const messgTopics = messageInfos;
          handleTopicsUpdate(messgTopics);
          // onLoading(false);
        })
        .catch((error) => {
          // Handle the error
          // onLoading(false);
          console.log("Error for UntreatedMessageData", error);

          console.log(JSON.stringify(error));
          setError(JSON.stringify(error));
        });
    };

    const apiUrl = "https://mailbox.semecloud.tech/get-threads";
    // const apiUrl = "http://localhost:55000/get-threads";
    await makeApiRequest(apiUrl, the_folder ? the_folder : "INBOX");
  };

  const onLoading = (val) => {
    setLoading(val);
  };

  const handleTopicsUpdate = (topics) => {
    setMessageInfos(topics);
  };

  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };

  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  async function triggerTimeout() {
    console.log("Start timeout from analytics.js");
    await new Promise((resolve) => setTimeout(resolve, 5000));
    await getDatas();
  }

  async function getEmployeeLink() {
    console.log("Start getting Employee link");

    var user_data_string = localStorage.getItem("authUser");

    if (!user_data_string) return;

    var user = JSON.parse(user_data_string);

    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "employee_link", [
      Query.equal("employee_id", user.userId)
    ]);

    return promise.then(
      async function (response) {
        console.log("Employee link is ", response.documents);
        return response.documents;
      },
      function (error) {
        onLoading(false);
        console.log("Error creating Employee link", error); // Failure
        return null;
      }
    );
  }

  async function getDatas() {
    console.log("Start getDatas");
    let employeeLink = await getEmployeeLink();
    if (!employeeLink || (employeeLink && employeeLink.length === 0)) {
      console.log("employeeLink is null", employeeLink);
      triggerTimeout();
    } else if (employeeLink && employeeLink.length > 0) {
      console.log("employeeLink not null", employeeLink);
      companyId = employeeLink[0].company_id;
      getMessageData([Date.now() - 7 * 24 * 60 * 60 * 1000, Date.now()]);
    }
  }

  async function getStatistics(start_date, end_date, new_aggregation = null) {
    console.log("Start getting Statistics");

    const company_id = localStorage.getItem("companyId");
    if (!company_id) return;

    try {
      const response = await fetchStatistics(
        company_id,
        new_aggregation ?? aggregation,
        start_date,
        end_date
      );
      setPageStatisticsList(response.documents);
      console.log({ statistics: response.documents });

      if (response.documents[0]) {
        const messagesSentiments = JSON.parse(
          response.documents[0].messages_sentiments
        );
        setMessagesSentiments(messagesSentiments);
      } else {
        setMessagesSentiments({
          happy: 0,
          angry: 0,
          neutral: 0
        });
      }
      console.log("Dashboard: Statistics is ", response.documents);
    } catch (error) {
      console.log("Error getting Statistics", error); // Failure
    }
  }

  function getAggregation(start_date, end_date) {
    const durationInDays = (end_date - start_date) / (1000 * 60 * 60 * 24);

    if (durationInDays <= 7) {
      return "H4";
    } else if (durationInDays > 7 && durationInDays <= 30) {
      return "WEEK";
    } else {
      return "MONTH";
    }
  }

  useEffect(() => {
    handleDateChange(Date.now() - 7 * 24 * 60 * 60 * 1000, Date.now());
    getDatas();
  }, []);

  const handleDateChange = (date_first, date_last) => {
    // console.log("Initial entrie dates are: ", date_first, date_last);

    setSelectedDates({ first: date_first, last: date_last });

    getMessageData([date_first, date_last]);

    const aggregation = getAggregation(date_first, date_last);
    console.log({ aggregation });
    setAggregation(aggregation);
    getStatistics(toStartOfDay(date_first), toEndOfDay(date_last), aggregation);
  };

  function toStartOfDay(dateInMillis) {
    const date = new Date(dateInMillis);
    date.setHours(0, 0, 0, 0); // Début du jour
    console.log("Statistics start is: ", date);
    return date;
  }

  function toEndOfDay(dateInMillis) {
    const date = new Date(dateInMillis);
    date.setHours(23, 59, 59, 999); // Fin du jour
    console.log("Statistics end is: ", date);
    return date;
  }
  const handleDateChangeFirst = (date) => {
    console.log("First entrie date is: " + date);
    setSelectedDates((prevState) => ({
      ...prevState,
      first: Date.parse(date)
    }));
    console.log("selectedDates is: " + selectedDates);

    if (selectedDates.last) {
      if (selectedDates.first === selectedDates.last) {
        selectedDates.last = selectedDates.first + 86400000;
      }
      getMessageData([selectedDates.first, selectedDates.last]);
      //  getTreatedMessageData([selectedDates.first, selectedDates.last]);
      //  getUntreatedMessageData([selectedDates.first, selectedDates.last]);
    }
  };

  const handleDateChangeLast = (date) => {
    console.log("Last entrie date is: " + date);
    setSelectedDates((prevState) => ({
      ...prevState,
      last: Date.parse(date)
    }));
    console.log("selectedDates is: " + selectedDates);
    if (selectedDates.last) {
      if (selectedDates.first === selectedDates.last) {
        selectedDates.last = selectedDates.first + 86400000;
      }
      getMessageData([selectedDates.first, selectedDates.last]);
      //  getTreatedMessageData([selectedDates.first, selectedDates.last]);
      //  getUntreatedMessageData([selectedDates.first, selectedDates.last]);
    }
  };

  const svgs = {
    info_icon: (
      <svg
        fill="currentColor"
        width="30"
        height="auto"
        viewBox="-1920 -1920 5760.00 5760.00"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" style={{ strokeWidth: "0" }} />

        <g
          id="SVGRepo_tracerCarrier"
          style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            style={{ fillRule: "evenodd" }}
            d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z"
          />{" "}
        </g>
      </svg>
    ),
    multiple_action_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M13.6431 0.22995L13.8549 0.172949C14.7141 -0.0286044 15.605 -0.0542117 16.4737 0.0972837L16.8441 0.172946C18.0875 0.464606 19.0816 1.39292 19.4691 2.64311L19.5261 2.855C19.7276 3.71419 19.7532 4.60494 19.5964 5.50205L19.5261 5.84406C19.2345 7.08745 18.3061 8.08157 17.0559 8.46907L16.8441 8.52607C15.9849 8.72762 15.094 8.75323 14.1969 8.59636L13.8549 8.52607C12.6115 8.23441 11.6174 7.30611 11.2299 6.05591L11.1729 5.84402C10.9424 4.86102 10.9424 3.838 11.1729 2.85496C11.4646 1.61157 12.3929 0.61745 13.6431 0.22995ZM16.4147 2.12625L16.1293 2.06752C15.5261 1.96232 14.9074 1.9801 14.345 2.1114L14.2013 2.14985C13.6613 2.31751 13.2488 2.75928 13.1192 3.31158C12.9592 3.99424 12.9592 4.7047 13.1106 5.35311L13.149 5.49682C13.3167 6.0368 13.7584 6.44932 14.2826 6.5727L14.568 6.63143C15.1713 6.73663 15.7899 6.71885 16.3523 6.58755L16.496 6.54909C17.036 6.38143 17.4485 5.93967 17.5719 5.41557L17.6306 5.13017C17.7358 4.52687 17.718 3.90826 17.5867 3.34583L17.5483 3.20213C17.3806 2.66215 16.9389 2.24963 16.4147 2.12625ZM2.85493 0.172947L2.64308 0.22995C1.39289 0.617444 0.464594 1.61155 0.172938 2.85494C-0.0576455 3.83798 -0.0576455 4.86104 0.172937 5.84407L0.229942 6.05593C0.617437 7.30612 1.61155 8.23442 2.85494 8.52608L3.19691 8.59636C4.09406 8.75323 4.98485 8.72762 5.84408 8.52607L6.05592 8.46907C7.30611 8.08158 8.23441 7.08747 8.52607 5.84408L8.59636 5.50211C8.75322 4.60495 8.72762 3.71416 8.52607 2.85494L8.46906 2.64309C8.08157 1.3929 7.08746 0.464602 5.84407 0.172945L5.47372 0.0972833C4.60495 -0.054211 3.71415 -0.0286046 2.85493 0.172947ZM5.1293 2.06752L5.41469 2.12625C5.93886 2.24963 6.38062 2.66214 6.54827 3.20214L6.58673 3.34585C6.71803 3.90829 6.73581 4.52685 6.63061 5.13012L6.57188 5.41551C6.4485 5.93968 6.03599 6.38144 5.49599 6.54909L5.35228 6.58755C4.78984 6.71885 4.17128 6.73663 3.56801 6.63143L3.28262 6.5727C2.75845 6.44932 2.31669 6.03681 2.14904 5.49681L2.11058 5.3531C1.95912 4.70468 1.95912 3.99426 2.11924 3.31164C2.24881 2.75927 2.66132 2.31751 3.20132 2.14986L3.34503 2.1114C3.90747 1.9801 4.52603 1.96232 5.1293 2.06752ZM2.85499 11.1729L2.6431 11.2299C1.39291 11.6174 0.464598 12.6115 0.172938 13.8549C-0.0576461 14.8379 -0.0576461 15.8611 0.172938 16.8441L0.229943 17.0559C0.617442 18.3061 1.61156 19.2345 2.85495 19.5261L3.19697 19.5964C4.09407 19.7532 4.98482 19.7276 5.84401 19.5261L6.05591 19.4691C7.3061 19.0816 8.23441 18.0875 8.52607 16.8441L8.59636 16.5021C8.75322 15.605 8.72762 14.7141 8.52606 13.8549L8.46906 13.6431C8.08156 12.3929 7.08744 11.4646 5.84405 11.1729L5.47367 11.0973C4.60493 10.9458 3.71418 10.9714 2.85499 11.1729ZM5.12935 13.0675L5.41475 13.1263C5.93885 13.2496 6.38062 13.6621 6.54827 14.2021L6.58673 14.3459C6.71803 14.9083 6.73581 15.5269 6.63061 16.1301L6.57188 16.4155C6.4485 16.9397 6.03598 17.3815 5.496 17.5491L5.35229 17.5876C4.78987 17.7188 4.17126 17.7366 3.56796 17.6314L3.28256 17.5727C2.75846 17.4493 2.31669 17.0368 2.14904 16.4968L2.11058 16.3531C1.95912 15.7047 1.95912 14.9942 2.11924 14.3116C2.24881 13.7593 2.66133 13.3175 3.20131 13.1498L3.34501 13.1114C3.90744 12.9801 4.52605 12.9624 5.12935 13.0675ZM13.855 11.1729L13.6431 11.2299C12.3929 11.6174 11.4646 12.6116 11.1729 13.855C10.9424 14.838 10.9424 15.8611 11.1729 16.844L11.2299 17.0559C11.6174 18.3061 12.6116 19.2345 13.855 19.5261L14.197 19.5964C15.0941 19.7532 15.9849 19.7276 16.844 19.5261L17.0559 19.4691C18.3061 19.0816 19.2344 18.0875 19.5261 16.8441L19.5964 16.5021C19.7532 15.605 19.7276 14.7142 19.5261 13.855L19.4691 13.6431C19.0816 12.3929 18.0874 11.4646 16.8441 11.1729L16.4737 11.0973C15.6049 10.9458 14.7142 10.9714 13.855 11.1729ZM16.1294 13.0675L16.4147 13.1262C16.9389 13.2496 17.3806 13.6621 17.5483 14.2021L17.5867 14.3458C17.718 14.9082 17.7358 15.5269 17.6306 16.1302L17.5719 16.4156C17.4485 16.9397 17.036 17.3815 16.496 17.5491L16.3523 17.5876C15.7899 17.7188 15.1713 17.7366 14.568 17.6314L14.2826 17.5727C13.7585 17.4493 13.3167 17.0368 13.149 16.4968L13.1106 16.3531C12.9592 15.7047 12.9592 14.9942 13.1192 14.3116C13.2488 13.7593 13.6613 13.3175 14.2013 13.1498L14.345 13.1114C14.9074 12.9801 15.5261 12.9624 16.1294 13.0675Z"
          fill="#563BFF"
        />
      </svg>
    ),
    create_new_icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4183 31.0354C15.5179 31.0354 14.8221 30.7898 14.3309 30.2986C13.8398 29.7666 13.5942 29.0503 13.5942 28.1498V18.0811H3.70969C2.85017 18.0811 2.17483 17.856 1.68367 17.4058C1.19251 16.9146 0.946936 16.2393 0.946936 15.3798C0.946936 14.5203 1.19251 13.8654 1.68367 13.4152C2.17483 12.924 2.85017 12.6784 3.70969 12.6784H13.5942V2.9167C13.5942 2.01624 13.8398 1.32044 14.3309 0.829281C14.8221 0.338126 15.5384 0.0925488 16.4797 0.0925488C17.3802 0.0925488 18.0555 0.338126 18.5058 0.829281C18.9969 1.32044 19.2425 2.01624 19.2425 2.9167V12.6784H29.127C30.0275 12.6784 30.7028 12.924 31.153 13.4152C31.6442 13.8654 31.8898 14.5203 31.8898 15.3798C31.8898 16.2393 31.6442 16.9146 31.153 17.4058C30.7028 17.856 30.0275 18.0811 29.127 18.0811H19.2425V28.1498C19.2425 29.0503 18.9969 29.7666 18.5058 30.2986C18.0555 30.7898 17.3597 31.0354 16.4183 31.0354Z"
          fill="#329993"
        />
      </svg>
    ),

    ///
    dropdown_x: (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.7415 21.108C21.4345 21.4308 21.1143 21.5964 20.7809 21.6048C20.4285 21.5951 20.0908 21.4368 19.768 21.1298L14.5267 16.1458L9.62389 21.3017C9.3169 21.6245 8.99669 21.7901 8.66325 21.7985C8.32982 21.8069 8.01118 21.6666 7.70733 21.3777C7.40349 21.0888 7.24737 20.7776 7.23898 20.4442C7.23059 20.1107 7.37989 19.7826 7.68687 19.4598L12.5896 14.3039L7.51922 9.48237C7.1774 9.15732 7.00229 8.82808 6.9939 8.49465C6.98551 8.16121 7.14384 7.82358 7.46888 7.48176C7.77587 7.15892 8.08705 7.0028 8.40243 7.0134C8.73587 7.00501 9.0735 7.16334 9.41532 7.48839L14.4857 12.3099L19.3885 7.15402C19.6955 6.83118 20.0157 6.66557 20.3491 6.65718C20.6826 6.64879 21.0012 6.78906 21.3051 7.07799C21.6089 7.36692 21.765 7.6781 21.7734 8.01153C21.7818 8.34497 21.6325 8.6731 21.3255 8.99594L16.4228 14.1518L21.6641 19.1358C21.9869 19.4428 22.162 19.7721 22.1894 20.1236C22.2159 20.438 22.0666 20.7661 21.7415 21.108Z"
          fill="#563BFF"
        />
      </svg>
    ),
    dropdown_screen: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8229 19.9114C15.043 19.9114 14.263 19.9114 13.4831 19.9114C13.034 19.9114 12.7031 19.6014 12.7031 19.1977C12.7031 18.7882 13.034 18.484 13.4831 18.484C14.9543 18.484 16.4315 18.484 17.9028 18.484C18.4818 18.484 18.8777 18.2383 19.0609 17.7762C19.1377 17.589 19.1495 17.396 19.1495 17.1971C19.1495 15.7405 19.1495 14.278 19.1495 12.8214C19.1495 12.4997 19.3445 12.2423 19.6399 12.1428C19.9353 12.0492 20.2367 12.137 20.4317 12.3768C20.5321 12.4997 20.5912 12.6401 20.5912 12.798C20.5912 14.3892 20.603 15.9803 20.5853 17.5656C20.5676 18.7765 19.4154 19.8938 18.1864 19.9114C17.4005 19.9231 16.6088 19.9114 15.8229 19.9114Z"
          fill="#329993"
        />
        <path
          d="M5.52411 0.267773C6.30406 0.267773 7.084 0.267773 7.86395 0.267773C8.31301 0.267773 8.6439 0.577814 8.6439 0.981451C8.6439 1.39094 8.31301 1.69513 7.86395 1.69513C6.39269 1.69513 4.91552 1.69513 3.44426 1.69513C2.84749 1.69513 2.43388 1.96422 2.26843 2.44391C2.20935 2.6194 2.19752 2.80075 2.19752 2.98209C2.19752 4.4387 2.19752 5.90115 2.19752 7.35776C2.19752 7.6795 2.00254 7.93689 1.7012 8.03634C1.41168 8.12993 1.10442 8.04219 0.909437 7.80234C0.808989 7.6795 0.749904 7.5391 0.755813 7.38116C0.755813 5.79 0.743994 4.19885 0.76172 2.61355C0.779446 1.40264 1.93755 0.285323 3.16064 0.267773C3.9465 0.256073 4.73235 0.267773 5.52411 0.267773Z"
          fill="#329993"
        />
        <path
          d="M20.5987 4.98849C20.5987 5.76066 20.5987 6.53284 20.5987 7.30502C20.5987 7.7496 20.2915 8.07719 19.8779 8.07719C19.4643 8.07719 19.157 7.7496 19.157 7.30502C19.157 5.85426 19.157 4.40351 19.157 2.95275C19.157 2.63101 19.092 2.33267 18.8734 2.07528C18.6193 1.78279 18.2766 1.69504 17.8985 1.69504C16.4095 1.69504 14.9205 1.69504 13.4315 1.69504C13.1065 1.69504 12.8406 1.50199 12.7461 1.2095C12.6516 0.922862 12.7402 0.618671 12.9825 0.425627C13.1065 0.32618 13.2483 0.267682 13.4079 0.273532C15.021 0.273532 16.634 0.255982 18.2471 0.285232C19.4584 0.302781 20.5751 1.44935 20.5987 2.66026C20.6046 3.42659 20.5928 4.21046 20.5987 4.98849Z"
          fill="#329993"
        />
        <path
          d="M5.51307 19.9114C4.76858 19.9114 4.02408 19.9173 3.27959 19.9114C1.89105 19.8997 0.756582 18.7883 0.750673 17.4194C0.744764 15.9043 0.750673 14.3833 0.750673 12.8682C0.750673 12.4237 1.05793 12.0961 1.47154 12.0961C1.88514 12.0961 2.19239 12.4237 2.19239 12.8741C2.19239 14.3307 2.19239 15.7932 2.19239 17.2498C2.19239 17.8289 2.45237 18.2325 2.93098 18.4022C3.11415 18.4665 3.30322 18.4841 3.49821 18.4841C4.96947 18.4841 6.44664 18.4841 7.9179 18.4841C8.2547 18.4841 8.51468 18.683 8.60922 18.993C8.69785 19.2855 8.59149 19.6014 8.33151 19.7827C8.19561 19.8822 8.04198 19.9114 7.87063 19.9114C7.09068 19.9114 6.29893 19.9114 5.51307 19.9114Z"
          fill="#329993"
        />
      </svg>
    ),
    dropdown_reload: (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.7299 4.39482C21.7299 5.22261 21.7229 6.0435 21.7369 6.8713C21.7369 7.07825 21.6741 7.15413 21.4581 7.15413C19.772 7.14723 18.0788 7.15413 16.3926 7.14723C16.323 7.14723 16.2324 7.17482 16.1975 7.11274C16.1557 7.02306 16.2533 6.98167 16.309 6.92648C16.7898 6.4505 17.2706 5.97452 17.7513 5.50544C18.0022 5.2571 18.0022 5.2571 17.7444 5.02946C16.2951 3.80156 14.6298 3.03586 12.7416 2.82201C10.0939 2.51848 7.73878 3.2635 5.71815 4.97427C4.06681 6.36772 3.16798 8.18887 2.8405 10.2928C2.79172 10.6102 2.80566 10.9482 2.8196 11.2724C2.82656 11.5138 2.72901 11.5897 2.49908 11.5828C1.94167 11.569 1.38425 11.569 0.826836 11.5828C0.569032 11.5897 0.499357 11.4862 0.506324 11.2448C0.513292 8.71314 1.41212 6.49189 3.00075 4.55348C4.88203 2.24255 7.34859 0.890491 10.3308 0.566272C13.7728 0.186866 16.8246 1.11813 19.3887 3.47734C19.556 3.63601 19.6605 3.6429 19.8277 3.47045C20.3782 2.90479 20.9425 2.35982 21.5069 1.80796C21.5627 1.75278 21.6184 1.6355 21.709 1.67689C21.7926 1.71828 21.7508 1.83555 21.7508 1.91144C21.7299 2.73923 21.7299 3.56702 21.7299 4.39482Z"
          fill="#FFAF2E"
        />
        <path
          d="M1.62852 18.6881C1.62852 17.8741 1.63549 17.0532 1.62156 16.2392C1.61459 15.9978 1.68427 15.9081 1.94207 15.9081C3.61431 15.915 5.28656 15.915 6.9588 15.915C7.03545 15.915 7.133 15.8805 7.1748 15.9633C7.20964 16.053 7.11209 16.0944 7.06332 16.1427C6.56164 16.6462 6.05997 17.1429 5.54436 17.6396C5.40501 17.7776 5.39804 17.8534 5.55133 17.9845C6.85429 19.1227 8.34537 19.8884 10.0594 20.1782C12.8674 20.6541 15.3827 19.9781 17.5706 18.1846C19.1244 16.9153 19.9953 15.239 20.3925 13.3075C20.497 12.8177 20.5667 12.3279 20.5528 11.8243C20.5458 11.5967 20.6155 11.5001 20.8663 11.507C21.4307 11.5208 21.9951 11.5208 22.5664 11.507C22.7894 11.5001 22.88 11.576 22.866 11.8036C22.6779 17.1774 18.9363 21.5302 13.6757 22.4132C10.359 22.972 7.32809 22.2476 4.65947 20.1919C4.42257 20.0057 4.18567 19.8125 3.97663 19.5918C3.80244 19.4055 3.7049 19.4469 3.55161 19.6056C3.00116 20.1644 2.43678 20.7162 1.87239 21.2681C1.81665 21.3233 1.76788 21.4198 1.69124 21.3923C1.58672 21.3578 1.6355 21.2405 1.6355 21.1646C1.62156 20.3368 1.62852 19.509 1.62852 18.6881Z"
          fill="#FFAF2E"
        />
      </svg>
    ),
    dropdown_directions: (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.86409 17.4193C9.86409 17.2823 9.86409 17.2138 9.86409 17.1453C9.86409 15.0846 9.86409 13.0296 9.86409 10.9688C9.86409 10.6891 9.86409 10.6891 9.58429 10.6891C7.52295 10.6891 5.46732 10.6891 3.40598 10.6891C3.33746 10.6891 3.26894 10.6891 3.19471 10.6891C3.20613 10.7919 3.28036 10.8204 3.32604 10.8718C3.76001 11.3113 4.2054 11.7452 4.63936 12.1904C4.95913 12.5101 4.97626 12.9211 4.69075 13.2179C4.39954 13.5148 3.96557 13.5034 3.64581 13.1894C2.75503 12.3046 1.87568 11.4198 0.996329 10.5407C0.648014 10.1925 0.648014 9.79288 0.990619 9.45038C1.87568 8.55986 2.76074 7.67506 3.65152 6.79025C3.95986 6.482 4.39383 6.47629 4.67933 6.76171C4.97055 7.05284 4.95913 7.46956 4.64507 7.78923C4.21111 8.22878 3.77143 8.66832 3.33175 9.10217C3.28036 9.15354 3.23468 9.20492 3.189 9.25629C3.25181 9.31338 3.32033 9.29054 3.38314 9.29054C5.4559 9.29054 7.52866 9.29054 9.60142 9.29625C9.81841 9.29625 9.87551 9.23346 9.87551 9.02225C9.8698 6.9558 9.8698 4.88935 9.8698 2.82861C9.8698 2.76581 9.8698 2.70302 9.8698 2.63452C9.77844 2.6231 9.74988 2.69161 9.70991 2.73156C9.25311 3.18253 8.80201 3.6392 8.3452 4.09017C8.03686 4.39272 7.62002 4.39842 7.33452 4.10729C7.04902 3.82187 7.05473 3.38803 7.36307 3.07978C8.04257 2.39477 8.72207 1.72117 9.40157 1.04187C9.61284 0.830659 9.82412 0.613739 10.0354 0.408235C10.3609 0.094272 10.7606 0.0828552 11.0803 0.402527C11.9882 1.29875 12.8904 2.20068 13.7869 3.10832C14.0838 3.40516 14.0724 3.84471 13.7869 4.12442C13.5014 4.39842 13.0903 4.39842 12.7934 4.10159C12.2966 3.61066 11.8112 3.11403 11.3202 2.6231C11.2345 2.65735 11.2631 2.71444 11.2631 2.76011C11.2631 4.86651 11.2631 6.97863 11.2573 9.08504C11.2573 9.22775 11.2859 9.30767 11.4572 9.30767C13.5871 9.30196 15.7169 9.30196 17.8468 9.30196C17.8753 9.30196 17.8982 9.29625 17.9267 9.29054C17.9267 9.20492 17.8582 9.17637 17.8182 9.13642C17.3786 8.69116 16.9332 8.25161 16.4878 7.80635C16.168 7.48668 16.1509 7.07567 16.4364 6.77884C16.7219 6.482 17.1616 6.48771 17.4813 6.80738C18.3664 7.68648 19.2458 8.56557 20.1251 9.45038C20.4734 9.8043 20.4734 10.2039 20.1194 10.5578C19.2458 11.4369 18.3664 12.3103 17.487 13.1837C17.1673 13.5034 16.7333 13.5205 16.4421 13.2294C16.1452 12.9325 16.1623 12.5158 16.4935 12.1904C16.9275 11.7566 17.3614 11.3227 17.7897 10.8889C17.8411 10.8375 17.8868 10.7861 17.9381 10.7348C17.8639 10.6777 17.7897 10.7005 17.7269 10.7005C15.6598 10.7005 13.5928 10.7005 11.5314 10.6948C11.3144 10.6948 11.2516 10.7519 11.2573 10.9688C11.2631 13.041 11.2631 15.1131 11.2631 17.1853C11.2631 17.2424 11.2631 17.2995 11.2631 17.3565C11.3544 17.3737 11.3773 17.2995 11.4229 17.2595C11.8855 16.8028 12.3366 16.3404 12.7991 15.8895C13.096 15.5984 13.5128 15.6041 13.7926 15.8838C14.0781 16.1692 14.0724 16.603 13.7641 16.9113C13.1988 17.4821 12.6278 18.053 12.0568 18.6181C11.737 18.9378 11.4229 19.2575 11.1032 19.5714C10.7549 19.9082 10.3552 19.9082 10.0068 19.5657C9.12178 18.6866 8.24242 17.8075 7.36307 16.9227C7.04331 16.603 7.0376 16.1692 7.33452 15.8781C7.63144 15.5926 8.03686 15.6098 8.36234 15.9294C8.8534 16.3975 9.33305 16.8827 9.86409 17.4193Z"
          fill="#FF7049"
        />
      </svg>
    ),
    calendar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
      >
        <path
          d="M14.703 16.609C11.0482 16.609 7.39331 16.609 3.73846 16.609C3.71251 16.6004 3.68656 16.596 3.6606 16.5917C2.52739 16.4014 1.70991 15.7915 1.19953 14.7621C1.05247 14.4637 0.974616 14.1436 0.914062 13.8192C0.914062 10.5666 0.914062 7.30969 0.914062 4.0571C0.978941 3.71973 1.0568 3.38668 1.21683 3.08391C1.85697 1.86851 2.87341 1.26298 4.24451 1.25433C4.72894 1.25 4.74192 1.25433 4.72462 0.782873C4.70732 0.406575 4.85438 0.151384 5.19607 0C5.31718 0 5.43396 0 5.55507 0C5.92704 0.155709 6.05247 0.337371 6.05247 0.743945C6.05247 0.83045 6.05247 0.916956 6.05247 1.00346C6.05247 1.25433 6.05247 1.25433 6.30334 1.25433C8.1805 1.25433 10.0533 1.25433 11.9305 1.25433C12.389 1.25433 12.402 1.25433 12.3847 0.804499C12.3674 0.423876 12.5058 0.155709 12.8561 0C12.9859 0 13.1156 0 13.2454 0C13.5957 0.151384 13.7514 0.41955 13.7168 0.800174C13.7082 0.895329 13.7212 0.99481 13.7168 1.08997C13.7125 1.20675 13.7601 1.25865 13.8769 1.25433C14.0499 1.25 14.2229 1.25 14.3959 1.25433C15.3215 1.29325 16.1001 1.64793 16.7229 2.33132C17.1684 2.82007 17.4149 3.40398 17.5274 4.05277C17.5274 7.30969 17.5274 10.5623 17.5274 13.8192C17.5187 13.8668 17.5058 13.9144 17.4971 13.9619C17.3241 14.8486 16.87 15.5493 16.1303 16.0684C15.6978 16.3668 15.2134 16.5268 14.703 16.609ZM9.21857 6.42734C6.96511 6.42734 4.71164 6.42734 2.45818 6.42734C2.23759 6.42734 2.22462 6.43599 2.22462 6.63495C2.22462 8.87976 2.22462 11.1203 2.22462 13.3651C2.22462 13.7241 2.31112 14.0614 2.50143 14.3685C2.91666 15.0346 3.53517 15.2985 4.29642 15.2985C7.57929 15.2941 10.8578 15.2985 14.1407 15.2941C14.3224 15.2941 14.5084 15.2855 14.69 15.2466C15.6113 15.0519 16.2125 14.295 16.2125 13.3305C16.2168 11.1289 16.2125 8.93167 16.2125 6.73011C16.2125 6.42734 16.2125 6.42734 15.9141 6.42734C13.6822 6.42734 11.4504 6.42734 9.21857 6.42734ZM9.20559 5.08218C11.4288 5.08218 13.6476 5.08218 15.8708 5.08218C15.9227 5.08218 15.979 5.07786 16.0309 5.08218C16.1606 5.09516 16.2212 5.04326 16.2125 4.90485C16.2039 4.76644 16.2125 4.62371 16.2082 4.4853C16.1866 3.64187 15.6719 2.9455 14.889 2.68599C14.5603 2.57786 14.2272 2.61246 13.8942 2.59948C13.7514 2.59516 13.7039 2.64706 13.7039 2.78979C13.7125 3.13582 13.7082 3.48184 13.7039 3.82786C13.6995 4.21713 13.4184 4.50692 13.0464 4.51125C12.6745 4.51557 12.3847 4.21713 12.3803 3.81921C12.376 3.47751 12.376 3.13582 12.3803 2.79844C12.3847 2.65139 12.3328 2.59948 12.1857 2.59948C10.2004 2.60381 8.21943 2.60381 6.23414 2.59948C6.09573 2.59948 6.0395 2.64274 6.04382 2.78547C6.05247 3.13149 6.04815 3.47751 6.04382 3.82353C6.0395 4.20848 5.75836 4.5026 5.39071 4.50692C5.01874 4.51125 4.72894 4.21713 4.72462 3.81921C4.72029 3.48616 4.72462 3.14879 4.72462 2.81575C4.72462 2.60813 4.71597 2.59948 4.51701 2.59948C4.36995 2.59948 4.22289 2.59516 4.08015 2.59948C3.40541 2.62111 2.88638 2.9282 2.51441 3.49049C2.24624 3.89706 2.20732 4.35986 2.22029 4.83132C2.22462 5.08218 2.22029 5.08218 2.47116 5.08218C4.72029 5.08218 6.96078 5.08218 9.20559 5.08218Z"
          fill="white"
        />
        <path
          d="M5.37333 9.61493C5.16139 9.61493 4.95378 9.61925 4.74184 9.61493C4.36987 9.6106 4.0844 9.32081 4.08008 8.95749C4.08008 8.59417 4.36555 8.30005 4.73319 8.29572C5.17004 8.2914 5.6069 8.2914 6.04375 8.29572C6.40274 8.30005 6.68821 8.59417 6.68821 8.95316C6.69254 9.30784 6.40707 9.60628 6.04807 9.61493C5.82748 9.61925 5.60257 9.61493 5.37333 9.61493Z"
          fill="white"
        />
        <path
          d="M13.0489 8.29135C13.2695 8.29135 13.4901 8.28703 13.7106 8.29135C14.0696 8.3 14.3508 8.59412 14.3508 8.95312C14.3508 9.31211 14.0696 9.60623 13.7063 9.61056C13.2651 9.61488 12.8196 9.61488 12.3785 9.61056C12.0195 9.60623 11.734 9.30346 11.7383 8.94879C11.7383 8.59412 12.0238 8.3 12.3828 8.29135C12.6034 8.28703 12.8283 8.29135 13.0489 8.29135Z"
          fill="white"
        />
        <path
          d="M5.38161 12.1195C5.6022 12.1195 5.82279 12.1152 6.04338 12.1195C6.4067 12.1281 6.68784 12.4136 6.69217 12.7726C6.69649 13.1316 6.4067 13.4344 6.03905 13.4387C5.60653 13.443 5.174 13.443 4.7458 13.4387C4.37383 13.4344 4.08836 13.1446 4.08403 12.7812C4.07971 12.4136 4.36517 12.1238 4.73715 12.1195C4.95341 12.1152 5.16967 12.1195 5.38161 12.1195Z"
          fill="white"
        />
        <path
          d="M9.22034 8.29135C9.4366 8.29135 9.65287 8.28703 9.86913 8.29135C10.2368 8.29568 10.5266 8.59412 10.5222 8.95744C10.5179 9.31211 10.2325 9.60623 9.87346 9.61056C9.4366 9.61488 8.99975 9.61488 8.5629 9.61056C8.19525 9.60623 7.90979 9.31211 7.91411 8.94447C7.91844 8.58547 8.19958 8.29568 8.55858 8.29135C8.77484 8.28703 8.99543 8.29135 9.22034 8.29135Z"
          fill="white"
        />
        <path
          d="M9.21401 13.443C9.00208 13.443 8.79446 13.4473 8.58253 13.443C8.19758 13.4387 7.91211 13.1489 7.91211 12.7769C7.91211 12.4092 8.19325 12.1238 8.56955 12.1195C9.00208 12.1151 9.4346 12.1151 9.8628 12.1195C10.2348 12.1238 10.5202 12.4179 10.5202 12.7812C10.5202 13.1445 10.2305 13.4343 9.85848 13.443C9.64221 13.443 9.43028 13.443 9.21401 13.443Z"
          fill="white"
        />
        <path
          d="M13.0488 13.443C12.8326 13.443 12.6163 13.4473 12.4 13.443C12.0281 13.4343 11.7383 13.1445 11.7383 12.7812C11.7383 12.4179 12.0237 12.1238 12.3957 12.1195C12.8282 12.1151 13.2608 12.1151 13.689 12.1195C14.0653 12.1238 14.3464 12.4092 14.3464 12.7769C14.3464 13.1445 14.0566 13.4343 13.676 13.443C13.4684 13.443 13.2608 13.443 13.0488 13.443Z"
          fill="white"
        />
      </svg>
    )
  };

  const [btnmenu1, setbtnmenu1] = useState(false);
  const [custom_dropdownIsOpen, setcustom_dropdownIsOpen] = useState(false);
  const [btnmenu_received, setbtnmenu_received] = useState(false);
  const [btnmenu_treated, setbtnmenu_treated] = useState(false);
  const [btnmenu_efficiency, setbtnmenu_efficiency] = useState(false);
  const [btnmenu_ca, setbtnmenu_ca] = useState(false);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container
          fluid={true}
          style={{ margin: "0", padding: "0", maxWidth: "100%" }}
        >
          <Row className="mb-xxl-4 mb-lg-0">
            <Col className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between pe-0 ps-0">
                <h4 className="page-title font-primary">
                  {props.t("Analytics").toUpperCase()}
                </h4>
                <div className="page-title-right mt-xxl-5 mt-lg-4 d-flex">
                  <div className="d-flex align-items-center font-primary">
                    <RangeDatepicker
                      range={selectedDates}
                      onChange={handleDateChange}
                    />
                    {/* <div style={{ position: "relative", marginRight: "9.13px" }}>
                      <div className="datePckr__iconContainer datePckr__iconContainer__start font-primary">{svgs.calendar_icon}</div>
                      <Flatpickr
                        className="datePckr__start form-control d-block font-primary"
                        placeholder="12 September 2023"
                        options={{
                          locale: locale ?? english,
                          mode: "single",
                          altInput: true,
                          altFormat: "j F Y",
                          dateFormat: "d-m-Y",
                        }}
                        value={selectedDates.first}
                        onChange={handleDateChangeFirst}
                      />
                      <i className="mdi mdi-chevron-down" style={{ position: "absolute", right: "6px", top: "30%" }}></i>
                    </div>
                    <span
                      className="font-primary"
                      style={{
                        marginRight: "23.3px",
                      }}>
                      à
                    </span>
                    <div style={{ position: "relative" }}>
                      <div className="datePckr__iconContainer datePckr__iconContainer__end font-primary">{svgs.calendar_icon}</div>
                      <Flatpickr
                        className="datePckr__end form-control d-block font-primary"
                        placeholder="18 September 2023"
                        options={{
                          locale: locale ?? english,
                          altInput: true,
                          altFormat: "j F Y",
                          dateFormat: "d-m-Y",
                        }}
                        value={selectedDates.last}
                        onChange={handleDateChangeLast}
                      />
                      <i className="mdi mdi-chevron-down" style={{ position: "absolute", right: "6px", top: "30%" }}></i>
                    </div> */}
                  </div>
                  {/* <div
                    style={{
                      position: 'relative',
                      width: '41.765px',
                      height: '41.765px',
                    }}>
                    <Dropdown
                      isOpen={custom_dropdownIsOpen}
                      toggle={() => setcustom_dropdownIsOpen(!custom_dropdownIsOpen)}
                      className="custom_dropdown"
                    // style={{ height: "fit-content", width: "fit-content" }}
                    >
                      <DropdownToggle tag="button" className="custom_dropdown_toggle">
                        {svgs.dropdown_x}
                      </DropdownToggle>
                      <DropdownMenu className="custom_dropdown_menu">
                        <DropdownItem className="custom_dropdown_item" style={{ animationDelay: '0.1s' }} onClick={() => { }}>
                          {svgs.dropdown_screen}
                        </DropdownItem>
                        <DropdownItem className="custom_dropdown_item" style={{ animationDelay: '0.15s' }} onClick={() => { }}>
                          {svgs.dropdown_reload}
                        </DropdownItem>
                        <DropdownItem className="custom_dropdown_item" style={{ animationDelay: '0.2s' }} onClick={() => { }}>
                          {svgs.dropdown_directions}
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div> */}
                </div>
              </div>
            </Col>
          </Row>

          {pageStatisticsList ? (
            <AreaOne
              statistics={pageStatisticsList}
              full={true}
              treatedMessage={treatedMessage}
              messages={mailMessages}
              untreatedMessage={untreatedMessage}
            />
          ) : (
            <AreaOne
              full={true}
              treatedMessage={treatedMessage}
              messages={mailMessages}
            />
          )}
          <Row>
            <Col lg={12} className="overview">
              {/* <Row className="justify-content-between">
                <div className="section__title col-auto">
                  Overview
                  <span style={{ cursor: "pointer" }}>{svgs.info_icon}</span>
                </div>
                <div
                  className="actions__container col-auto"
                  style={{ marginBottom: "30px" }}
                >
                  <button
                    type="button"
                    style={{
                      height: "40px",
                      width: "40px",
                      border: "none",
                      background: "none",
                      padding: "0",
                      marginRight: "10px"
                    }}
                  >
                    {svgs.multiple_action_icon}
                  </button>
                  <button
                    type="button"
                    className="close-btn"
                    style={{
                      border: "none",
                      padding: "7px 22px 8px 23px",
                      borderRadius: "12.284px",
                      background: "#f10944",
                      boxShadow:
                        "0px 17.19734px 44.22173px 0px rgba(255, 73, 73, 0.20)",
                      color: "#fff",
                      textAlign: "center",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "17.197px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "29.481px",
                    }}
                  >
                    Close
                  </button>
                </div>
              </Row>
               */}
              <Row className="overview_row">
                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div
                          className="section__title__md col-xl-auto col-xxl-auto font-primary"
                          style={{ position: "relative" }}
                        >
                          {props.t("Mails reçus")}
                          <span
                            className="font-primary"
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(1, props.t("Emails reçus"))
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 1 && (
                            <div
                              className="hover-text-dashboard font-primary"
                              style={{
                                right: "0",
                                top: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(115%, -80%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                      </Row>
                      <ReceiveMail
                        statistics={pageStatisticsList}
                        messages={messages_data}
                      />
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div
                          className="section__title__md col-xl-auto col-xxl-auto font-primary"
                          style={{ position: "relative" }}
                        >
                          {props.t("Messages traités")}
                          <span
                            className="font-primary"
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(
                                2,
                                props.t(
                                  "Visualise comment le nombre d'emails traités par Synibox change avec le temps."
                                )
                              )
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {svgs.info_icon}
                            {hoverText[0] === 2 && (
                              <div
                                className="hover-text-dashboard font-primary"
                                style={{
                                  right: "0",
                                  top: "0",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(60%, -110%)"
                                }}
                              >
                                {hoverText[1]}
                              </div>
                            )}
                          </span>
                        </div>
                        {/* <div
                          className="actions__container col-sm-auto"
                          style={{ padding: "0" }}
                        >
                          <Dropdown
                            isOpen={btnmenu_treated}
                            toggle={() => setbtnmenu_treated(!btnmenu_treated)}
                            className=""
                            style={{ height: "fit-content" }}
                          >
                            <DropdownToggle
                              tag="button"
                              className=""
                              style={{
                                backgroundColor: "inherit",
                                border: "none",
                                color: "#A0A0A0",
                              }}
                            >
                              {svgs.multiple_action_icon}
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-sm-end"
                              style={{ color: "#1E222C" }}
                            >
                              <DropdownItem onClick={() => { }}>
                                Aujourd'hui
                              </DropdownItem>
                              <DropdownItem>Hier</DropdownItem>
                              <DropdownItem onClick={() => { }}>
                                7 derniers jours
                              </DropdownItem>
                              <DropdownItem onClick={() => { }}>
                                30 derniers jours
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div> */}
                      </Row>
                      <TreatedMail
                        statistics={pageStatisticsList}
                        messages={treatedMessage}
                      />
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div
                          className="section__title__md col-xl-auto col-xxl-auto font-primary"
                          style={{ position: "relative" }}
                        >
                          {props.t("Efficiency")}
                          <span
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(
                                3,
                                props.t("Efficiency Rate")
                              )
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 3 && (
                            <div
                              className="hover-text-dashboard font-primary"
                              style={{
                                right: "0",
                                top: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(115%, -80%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                        {/* <div
                          className="actions__container col-sm-auto"
                          style={{ padding: "0" }}
                        >
                          <Dropdown
                            isOpen={btnmenu_efficiency}
                            toggle={() => setbtnmenu_efficiency(!btnmenu_efficiency)}
                            className=""
                            style={{ height: "fit-content" }}
                          >
                            <DropdownToggle
                              tag="button"
                              className=""
                              style={{
                                backgroundColor: "inherit",
                                border: "none",
                                color: "#A0A0A0",
                              }}
                            >
                              {svgs.multiple_action_icon}
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-sm-end"
                              style={{ color: "#1E222C" }}
                            >
                              <DropdownItem onClick={() => { }}>
                                Aujourd'hui
                              </DropdownItem>
                              <DropdownItem>Hier</DropdownItem>
                              <DropdownItem onClick={() => { }}>
                                7 derniers jours
                              </DropdownItem>
                              <DropdownItem onClick={() => { }}>
                                30 derniers jours
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div> */}
                      </Row>
                      <Efficiency
                        statistics={pageStatisticsList}
                        messages={treatedMessage}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {/* <Row className="overview_row">
                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div className="section__title__md col-xl-auto col-xxl-auto font-primary" style={{ position: "relative" }}>
                          {props.t("Chiffre d'Affaire")}
                          <span
                            className="font-primary"
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onMouseEnter={() => handleIconMouseEnter(4, props.t("Représente l'évolution du chiffre d'affaires de la boutique."))}
                            onMouseLeave={handleIconMouseLeave}>
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 4 && (
                            <div
                              className="hover-text-dashboard font-primary"
                              style={{ right: "0", top: "0", padding: "5px 10px", fontWeight: "400", transform: "translate(115%, -80%)" }}>
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                      </Row>
                      <Turnover messages={[]} />
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div className="section__title__md col-xl-auto col-xxl-auto font-primary" style={{ position: "relative" }}>
                          {props.t("C.A Synibox")}
                          <span
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(5, props.t("Affiche le chiffre d'affaires résultant directement des interactions avec Synibox."))
                            }
                            onMouseLeave={handleIconMouseLeave}>
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 5 && (
                            <div
                              className="hover-text-dashboard font-primary"
                              style={{ right: "0", top: "0", padding: "5px 10px", fontWeight: "400", transform: "translate(115%, -80%)" }}>
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                      </Row>
                      <TurnoverAi messages={[]} />
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ height: "293px" }}>
                    <CardBody className="d-flex flex-column">
                      <Row className="justify-content-between align-items-center">
                        <div className="section__title__md col-xl-auto col-xxl-auto font-primary" style={{ position: "relative" }}>
                          {props.t("Ratio C.a/Email")}
                          <span
                            style={{
                              height: "fit-content",
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onMouseEnter={() => handleIconMouseEnter(6, props.t("Calcule le revenu moyen généré par email traité."))}
                            onMouseLeave={handleIconMouseLeave}>
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 6 && (
                            <div
                              className="hover-text-dashboard font-primary"
                              style={{ right: "0", top: "0", padding: "5px 10px", fontWeight: "400", transform: "translate(115%, -80%)" }}>
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                      </Row>
                      <Ratio messages={[]} />
                    </CardBody>
                  </Card>
                </Col>
              </Row> */}
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xxl={8} xl={7}>
              <Card
                className="analyseMessageSavHeure_card h-100"
                style={{
                  margin: "0",
                  borderRadius: "10px",
                  boxShadow: "none",
                  border: "1px solid #dcdcdc"
                }}
              >
                <CardBody
                  style={{ padding: "2rem" }}
                  className="d-flex flex-column"
                >
                  <Row className="justify-content-between">
                    <div className="section__title d-flex col-xl-auto gap-xxl-2 font-primary">
                      {props.t("Activités par heure")}
                      <span
                        style={{ cursor: "pointer", cursor: "pointer" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            13,
                            props.t(
                              "Montre la répartition des emails reçus par heure."
                            )
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 13 && (
                        <div
                          className="hover-text-dashboard font-primary"
                          style={{
                            top: "20%",
                            right: "",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(120%, -150%)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                  </Row>

                  <AnalyseMessageSavHeure
                    statistics={pageStatisticsList}
                    messages={messages_data}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xxl={4} xl={5}>
              <Card
                className="realtime-stats h-100 mb-0"
                style={{
                  borderRadius: "10px",
                  boxShadow: "none",
                  border: "1px solid #dcdcdc"
                }}
              >
                <CardBody style={{ padding: "2rem" }}>
                  <Row className="justify-content-between">
                    <div className="section__title col-auto font-primary">
                      {props.t("Temps moyen de réponse")}
                      <span
                        style={{ cursor: "pointer", cursor: "pointer" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            15,
                            props.t("Temps moyen de réponse")
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 15 && (
                        <div
                          className="hover-text-dashboard font-primary"
                          style={{
                            top: "20%",
                            right: "",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(120%, -150%)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                    {/* <div className="actions__container col-sm-auto">
                      <button
                        type="button"
                        style={{
                          height: "40px",
                          width: "40px",
                          border: "none",
                          background: "none",
                          padding: "0",
                        }}
                      >
                        {svgs.multiple_action_icon}
                      </button>
                    </div> */}
                  </Row>
                  <TempsReponsePerformances
                    statistics={pageStatisticsList}
                    messages={messages_data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xxl={8} xl={7}>
              <Card
                className="mb-0"
                style={{
                  borderRadius: "10px",
                  border: "1px solid #dcdcdc",
                  height: "100%"
                }}
              >
                <CardBody
                  style={{ padding: "2rem" }}
                  className="d-flex flex-column"
                >
                  <VueGlobale
                    statistics={pageStatisticsList}
                    messages={messages_data}
                  >
                    {" "}
                  </VueGlobale>
                </CardBody>
              </Card>
            </Col>
            <Col xxl={4} xl={5}>
              <Card
                className="languages__card"
                style={{
                  margin: "0",
                  borderRadius: "10px",
                  border: "1px solid #dcdcdc",
                  height: "420px"
                }}
              >
                <CardBody
                  style={{ padding: "2rem" }}
                  className="d-flex flex-column"
                >
                  <Row className="justify-content-between">
                    <div className="section__title col-xl-auto col-xxl-auto font-primary">
                      {props.t("Langues")}
                      <span
                        style={{ cursor: "pointer", cursor: "pointer" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(7, props.t("Langues"))
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 7 && (
                        <div
                          className="hover-text-dashboard"
                          style={{
                            top: "0",
                            right: "0",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(120%, 0)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                    {/* <div className="actions__container col-sm-auto">

                                          <button
                                            className="me-xl-0"
                                            type="button"
                                            style={{
                                              height: "40px",
                                              width: "40px",
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              marginRight: "10px",
                                            }}
                                          >
                                            {svgs.multiple_action_icon}
                                          </button>
                                          <button
                                            type="button"
                                            className="close-btn"
                                            style={{
                                              border: "none",
                                              padding: "6px 18px 6px 19px",
                                              borderRadius: "10px",
                                              background: "#f10944",
                                              boxShadow:
                                                "0px 14px 36px 0px rgba(255, 73, 73, 0.2)",
                                              color: "#fff",
                                              textAlign: "center",
                                              fontFamily: "Poppins, sans-serif",
                                              fontSize: "14px",
                                              fontStyle: "normal",
                                              fontWeight: "500",
                                              lineHeight: "24px",
                                            }}
                                          >
                                            Close
                                          </button>
                                        </div> */}
                  </Row>
                  <LangageStateChart
                    statistics={pageStatisticsList}
                    messages={messages_data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col lg={12}>
              <Card
                className="clients-great-feedbacks mb-0"
                style={{ borderRadius: "10px", border: "1px solid #dcdcdc" }}
              >
                <CardBody style={{ padding: "2rem" }}>
                  <Row className="justify-content-between">
                    <div className="section__title col-sm-auto mb-4">
                      {props.t("Observations Pertinentes Clients")}
                      <span
                        style={{ cursor: "pointer", cursor: "pointer" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            8,
                            props.t("Observations Pertinentes Clients")
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 8 && (
                        <div
                          className="hover-text-dashboard"
                          style={{
                            top: "0",
                            right: "0",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(120%, 0)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                    {/* <div className="actions__container col-sm-auto">
                                    <button
                                      type="button"
                                      style={{
                                        height: "40px",
                                        width: "40px",
                                        border: "none",
                                        background: "none",
                                        padding: "0",
                                        marginRight: "10px",
                                      }}
                                    >
                                      {svgs.multiple_action_icon}
                                    </button>
              
                                    <button
                                      type="button"
                                      className="close-btn"
                                      style={{
                                        border: "none",
                                        padding: "6px 18px 6px 19px",
                                        borderRadius: "10px",
                                        background: "#f10944",
                                        boxShadow: "0px 14px 36px 0px rgba(255, 73, 73, 0.2)",
                                        color: "#fff",
                                        textAlign: "center",
                                        fontFamily: "Poppins, sans-serif",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                        lineHeight: "24px",
                                      }}
                                    >
                                      Close
                                    </button>
                                  </div> */}
                  </Row>
                  <RetoursClients messages={[]} folder="INBOX"></RetoursClients>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <AreaTwo treatedMessage={treatedMessage} messages={messages} /> */}

          {/* <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                   <StateChart messages={messages} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle>Sentiments clients</CardTitle>
                  <p className="card-title-desc">Lorm ipsum dolor</p>
                  <ClientSentiments messages={messages} />
                </CardBody>
              </Card>
            </Col>
          </Row> */}

          <Row className="mb-4">
            <Col xxl={8} xl={7}>
              <Card
                style={{ height: "420px" }}
                className="attention_languages mb-0"
              >
                <CardBody className="h-100" style={{ padding: "0" }}>
                  <Row className="h-100">
                    <Col className="attention_languages__attention d-flex flex-column h-100">
                      <Row className="justify-content-between font-primary">
                        <div className="section__title col-auto font-primary">
                          {props.t("Évolution Satisfaction Clients")}
                          <span
                            style={{ cursor: "pointer", cursor: "pointer" }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(
                                6,
                                props.t("Évolution Satisfaction Clients")
                              )
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {svgs.info_icon}
                          </span>
                          {hoverText[0] === 6 && (
                            <div
                              className="hover-text-dashboard"
                              style={{
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(120%, 0)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                        </div>
                        {/* <div className="actions__container col-sm-auto">
                                              <Dropdown
                                                isOpen={btnmenu1}
                                                toggle={() => setbtnmenu1(!btnmenu1)}
                                                className=""
                                                style={{ height: "fit-content" }}
                                              >
                                                <DropdownToggle
                                                  tag="button"
                                                  className=""
                                                  style={{
                                                    backgroundColor: "inherit",
                                                    border: "none",
                                                    color: "#A0A0A0",
                                                  }}
                                                >
                                                  {svgs.multiple_action_icon}
                                                </DropdownToggle>
                                                <DropdownMenu
                                                  className="dropdown-menu-sm-end"
                                                  style={{ color: "#1E222C" }}
                                                >
                                                  <DropdownItem onClick={() => { }}>
                                                    Aujourd'hui
                                                  </DropdownItem>
                                                  <DropdownItem>Hier</DropdownItem>
                                                  <DropdownItem onClick={() => { }}>
                                                    7 derniers jours
                                                  </DropdownItem>
                                                  <DropdownItem onClick={() => { }}>
                                                    30 derniers jours
                                                  </DropdownItem>
                                                </DropdownMenu>
                                              </Dropdown>
                                            </div> */}
                      </Row>
                      {/* <p className="attention_languages__text">
                                          {' '}
                                          {props.t('customer_response_subtitle')}{' '}
                                        </p> */}
                      <div className="d-flex flex-column" style={{ flex: "1" }}>
                        <SentimentChart
                          statistics={pageStatisticsList}
                          messages={messages_data}
                        />
                        {pageStatisticsList &&
                          pageStatisticsList.length > 0 && (
                            <div className="customLegend">
                              <div className="d-flex">
                                <div className="legend satisfied"></div>
                                <span className="font-primary">
                                  {props.t("Satisfait")}
                                </span>
                              </div>
                              <div className="d-flex">
                                <div className="legend neutral"></div>
                                <span className="font-primary">
                                  {props.t("Neutre")}
                                </span>
                              </div>
                              <div className="d-flex">
                                <div className="legend dissatisfied"></div>
                                <span className="font-primary">
                                  {props.t("Mécontent")}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xxl={4} xl={5}>
              <Card
                className="client-feeling mb-0 h-100"
                style={{ borderRadius: "10px", border: "1px solid #dcdcdc" }}
              >
                <CardBody
                  style={{ padding: "2rem" }}
                  className="d-flex flex-column"
                >
                  <Row
                    className="justify-content-between"
                    style={{ flexWrap: "nowrap" }}
                  >
                    <div
                      className="section__title col-sm-auto font-primary"
                      style={{ marginBottom: "16px", cursor: "pointer" }}
                    >
                      {props.t("Sentiments clients")}
                      <span
                        onMouseEnter={() =>
                          handleIconMouseEnter(2, props.t("Sentiments clients"))
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 2 && (
                        <div
                          className="hover-text-dashboard font-primary"
                          style={{
                            top: "0",
                            right: "0",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(120%, 0)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                    {/* <div
                                            className="actions__container col-sm-auto"
                                            style={{ padding: "0" }}
                                          >
                                            <button
                                              type="button"
                                              style={{
                                                height: "30px",
                                                width: "40px",
                                                border: "none",
                                                background: "none",
                                                padding: "0",
                                              }}
                                            >
                                              {svgs.multiple_action_icon}
                                            </button>
                                          </div> */}
                  </Row>
                  {messagesSentiments ? (
                    <div
                      className="d-flex justify-content-between flex-column"
                      style={{ flex: "1" }}
                    >
                      <div
                        className="feelings__container text-center"
                        dir="ltr"
                        style={{
                          padding: "30px 0 30px 0",
                          borderRadius: "10px"
                          // background: '#FFAE2E',
                        }}
                      >
                        {/* <div className="top-left__div"></div>
                                          <div className="top-right__div"></div>
                                          <div className="bottom-right__div"></div>
                                          <div className="bottom-right-outlined__div"></div> */}
                        <Row>
                          <Col sm={4}>
                            <p className="emoji-title font-primary">
                              {messagesSentiments.happy +
                                messagesSentiments.angry +
                                messagesSentiments.neutral ===
                              0
                                ? "-- "
                                : (
                                    (messagesSentiments.happy * 100) /
                                    (messagesSentiments.happy +
                                      messagesSentiments.angry +
                                      messagesSentiments.neutral)
                                  ).toFixed(0)}{" "}
                              %
                            </p>
                            <img src={love} style={{ width: "40px" }} />
                          </Col>
                          <Col sm={4}>
                            <p className="emoji-title font-primary">
                              {messagesSentiments.happy +
                                messagesSentiments.angry +
                                messagesSentiments.neutral ===
                              0
                                ? "-- "
                                : (
                                    (messagesSentiments.neutral * 100) /
                                    (messagesSentiments.happy +
                                      messagesSentiments.angry +
                                      messagesSentiments.neutral)
                                  ).toFixed(0)}{" "}
                              %
                            </p>
                            <img src={neutral} style={{ width: "40px" }} />
                          </Col>
                          <Col sm={4}>
                            <p className="emoji-title font-primary">
                              {messagesSentiments.happy +
                                messagesSentiments.angry +
                                messagesSentiments.neutral ===
                              0
                                ? "-- "
                                : (
                                    (messagesSentiments.angry * 100) /
                                    (messagesSentiments.happy +
                                      messagesSentiments.angry +
                                      messagesSentiments.neutral)
                                  ).toFixed(0)}{" "}
                              %
                            </p>
                            <img src={hate} style={{ width: "40px" }} />
                          </Col>
                        </Row>
                      </div>
                      <div
                        className="mt-2 font-size-15 d-flex align-items-center gap-1 font-primary"
                        style={{ color: "#563bff" }}
                      >
                        <a href="mailto:contact@semecloud.tech">
                          <i className="ri-information-fill font-size-16"></i>{" "}
                          {props.t("Comment l'améliorer ?")}
                        </a>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle>Messages traités  ({treatedMessage.length})</CardTitle>
                  <p className="card-title-desc">Vue globale du nombre d'e-mails répondu en plus des motifs de contact pour lesquels vos clients vous ont contacté sur cette période</p>
                  <TreatedEmail messages={treatedMessage} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle>Mails non traités ({untreatedMessage.length})</CardTitle>
                  <p className="card-title-desc">Vue globale du nombre d'e-mails non répondu en plus des motifs de contact pour lesquels vos clients vous ont contacté sur cette période.</p>
                  <UntreatedEmail messages={untreatedMessage} />
                </CardBody>
              </Card>
            </Col>

          </Row>  */}

          {/* <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Langues</CardTitle>
                  <Langues messages={messages} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Vos clients dans le monde</CardTitle>
                  <ClientsMonde />
                </CardBody>
              </Card>
            </Col>
          </Row> */}

          <Row className="mb-4">
            <Col lg={12}>
              <Card
                style={{
                  marginBottom: "0",
                  borderRadius: "10px",
                  border: "2px solid #dcdcdc"
                }}
                className="response-rate-progression font-primary"
              >
                <CardBody
                  className="d-flex flex-column"
                  style={{
                    height: "420px",
                    padding: "2rem"
                  }}
                >
                  <Row className="justify-content-between">
                    <div className="section__title d-flex col-auto gap-xxl-2 font-primary">
                      {props.t("Progression Taux Réponse Synibox")}
                      {/* <p
                        className="align-self-xl-start align-self-xxl-end simple-text"
                        style={{
                          fontWeight: '400',
                          margin: '0',
                          color: '#A4ABB9',
                        }}>
                        ({props.t("Mensuel comparé au mois précédent")})
                      </p> */}
                      <span
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            9,
                            props.t("Progression Taux Réponse Synibox")
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 9 && (
                        <div
                          className="hover-text-dashboard"
                          style={{
                            top: "0",
                            right: "0",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(110%, 0)"
                          }}
                        >
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                    {/* <div className="actions__container col-sm-auto">
                                      <Dropdown
                                        isOpen={btnmenu1}
                                        toggle={() => setbtnmenu1(!btnmenu1)}
                                        className=""
                                        style={{ height: "fit-content" }}
                                      >
                                        <DropdownToggle
                                          tag="button"
                                          className=""
                                          style={{
                                            backgroundColor: "inherit",
                                            border: "none",
                                            color: "#A0A0A0",
                                            height: "40px",
                                            width: "40px",
                                            marginRight: "10px",
                                          }}
                                        >
                                          {svgs.multiple_action_icon}
                                        </DropdownToggle>
                                        <DropdownMenu
                                          className="dropdown-menu-sm-end"
                                          style={{ color: "#1E222C" }}
                                        >
                                          <DropdownItem onClick={() => { }}>
                                            Aujourd'hui
                                          </DropdownItem>
                                          <DropdownItem>Hier</DropdownItem>
                                          <DropdownItem onClick={() => { }}>
                                            7 derniers jours
                                          </DropdownItem>
                                          <DropdownItem onClick={() => { }}>
                                            30 derniers jours
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                      <button
                                        type="button"
                                        className="close-btn"
                                        style={{
                                          border: "none",
                                          padding: "6px 18px 6px 19px",
                                          borderRadius: "10px",
                                          background: "#f10944",
                                          boxShadow: "0px 14px 36px 0px rgba(255, 73, 73, 0.2)",
                                          color: "#fff",
                                          textAlign: "center",
                                          fontFamily: "Poppins, sans-serif",
                                          fontSize: "14px",
                                          fontStyle: "normal",
                                          fontWeight: "500",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        Close
                                      </button>
                                    </div> */}
                  </Row>
                  <ProgressionBar statistics={pageStatisticsList} />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <Col xl={4}>
            <Card className="analyseMessageSavJour_card" style={{ borderRadius: '20px', boxShadow: ' 0px 4px 32px 0px rgba(0, 0, 0, 0.05)' }}>
              <CardBody>
                <Row className="justify-content-between">
                  <div className="section__title d-flex col-xl-9 gap-xxl-2">
                    {props.t("Activités par jour de la semaine")}
                    <span
                      style={{ cursor: 'pointer', cursor: 'pointer' }}
                      onMouseEnter={() => handleIconMouseEnter(14, props.t("Activités par jour de la semaine"))}
                      onMouseLeave={handleIconMouseLeave}>
                      {svgs.info_icon}
                    </span>
                    {hoverText[0] === 14 && (
                      <div
                        className="hover-text-dashboard col-auto"
                        style={{ top: '0', right: '0', padding: '5px 10px', fontWeight: '400', transform: 'translate(70%, -100%)' }}>
                        {hoverText[1]}
                      </div>
                    )}
                  </div>
                </Row>
                <AnalyseMessageSavJour messages={messages_data} />
              </CardBody>
            </Card>
          </Col> */}
          {/* <Row>
             <Col xl={8}>
              <Card className="client-satisfaction" style={{ borderRadius: "20px", boxShadow: " 0px 4px 32px 0px rgba(0, 0, 0, 0.05)" }}>
                <CardBody>
                  <Row className="justify-content-between">
                   
                    <div className="section__title col-sm-auto">
                      Sentiments clients
                      <span
                        onMouseEnter={() => handleIconMouseEnter(10, "Sentiments clients")}
                        onMouseLeave={handleIconMouseLeave}
                        style={{ cursor: "pointer", cursor: "pointer" }}>
                        {svgs.info_icon}
                      </span>
                      {
                        hoverText[0] === 10 && <div className="hover-text-dashboard" style={{top:"20%", right: "0", padding:"5px 10px", fontWeight:"400", transform:"translateX(120%)"}}>{hoverText[1]}</div>
                      }
                    </div>
                  </Row>
                  <ClientsSentiments messages={messages} />
                </CardBody>
              </Card>
            </Col> 
          </Row> */}

          {/* <Row className="mb-xl-5 mt-xl-4"> */}
          {/* <Col lg={4}>
              <Card className="usals-tags" style={{ borderRadius: '20px', boxShadow: '0px 4px 32px 0px rgba(0, 0, 0, 0.05)' }}>
                <CardBody style={{ paddingTop: '34px' }}>
                  <Row className="justify-content-between" style={{ flexWrap: 'nowrap' }}>
                    <div className="section__title col-xl-7 col-xxl-auto" style={{ marginBottom: '16px', cursor: 'pointer', position: 'relative' }}>
                    {props.t("Tags les plus utilisés")}
                      <span onMouseEnter={() => handleIconMouseEnter(8, props.t("Tags les plus utilisés"))} onMouseLeave={handleIconMouseLeave}>
                        {svgs.info_icon}
                      </span>
                      {hoverText[0] === 8 && (
                        <div
                          className="hover-text-dashboard"
                          style={{ right: '0', top: '0', padding: '5px 10px', fontWeight: '400', transform: 'translate(100%, -120%)' }}>
                          {hoverText[1]}
                        </div>
                      )}
                    </div>
                  </Row>

                  <TagsList messages={messages_data} />
                </CardBody>
              </Card>
            </Col> */}

          {/* <Col lg={8}>
              <Card className="global-view" style={{ margin: "0", borderRadius: "20px", boxShadow: " 0px 4px 32px 0px rgba(0, 0, 0, 0.05)" }}>
                <CardBody>
                  <Row className="justify-content-between">
                    
                    <div className="section__title col-sm-auto">
                      Vue globale
                      <span
                        onMouseEnter={() => handleIconMouseEnter(12, "Vue globale")}
                        onMouseLeave={handleIconMouseLeave}
                        style={{ cursor: "pointer", cursor: "pointer" }}>
                        {svgs.info_icon}
                      </span>
                      {
                        hoverText[0] === 12 && <div className="hover-text-dashboard" style={{ top: "20%", right: "0", padding: "5px 10px", fontWeight: "400", transform: "translate(120%, -80%)" }}>{hoverText[1]}</div>
                      }
                    </div>
                  </Row>
                  <VueGlobale messages={messages} />
                </CardBody>
              </Card>
            </Col> */}
          {/* </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Analytics);
